/* global System */
// register component(s) with react habitat

export default { ExampleComponent: () => System.import('./index') }
